<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Logo Lukinet -->
    <b-link
      class="navbar-brand-logo d-none d-sm-flex align-items-center mr-2"
      to="/"
    >
      <img
        src="/logo%20Lukinet.png"
        alt="Lukinet"
        class="navbar-logo-img"
      >
    </b-link>
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <!-- Bookmarks Container -->
      <bookmarks />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <locale />
      <dark-Toggler class="d-none d-lg-block" />
      <!--<search-bar />//-->
      <!--<cart-dropdown />//-->
      <!--<notification-dropdown />//-->
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav } from 'bootstrap-vue'
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import DarkToggler from './components/DarkToggler.vue'
import UserDropdown from './components/UserDropdown.vue'

export default {
    components: {
        BLink,
        BNavbarNav,
        Bookmarks,
        Locale,
        DarkToggler,
        UserDropdown,
    },
    props: {
        toggleVerticalMenuActive: {
            type: Function,
            default: () => {},
        },
    },
}
</script>

<style lang="scss" scoped>
.navbar-brand-logo {
    flex-shrink: 0;
    max-width: 100px;
    line-height: 0;
    .navbar-logo-img {
        display: block;
        max-height: 28px !important;
        max-width: 100% !important;
        width: auto !important;
        height: auto !important;
        object-fit: contain;
    }
}
</style>
